import React, { useContext, useState } from 'react'
import { Button, Table, Tooltip } from 'antd'
import { EditTwoTone } from '@ant-design/icons'
import { useQuery } from '@apollo/react-hooks'
import moment from 'moment'

import Page404 from 'components/Page404'
import CustomMeta from 'components/CustomMeta'
import { AppContext } from 'AppContext'
import { canUserEdit } from 'utils/User'
import { DAYS } from 'utils/workingHours'
import { GET_WORKING_HOURS } from './graphql/Query'
import EditWorkingHours from './EditWorkingHours'

const formatTime = (time) => moment(time, 'HH:mm').format('h:mm a')

const describeDay = (row) => {
  if (!row) return 'Not set'
  if (row.isClosed) return 'Closed'
  if (row.isOpen24Hours) return 'Open 24 hours'
  if (!row.slots?.length) return 'Closed'
  return row.slots
    .map((slot) => `${formatTime(slot.openTime)} – ${formatTime(slot.closeTime)}`)
    .join(', ')
}

const WorkingHours = () => {
  const [editDays, setEditDays] = useState(null)
  const { data, loading, error } = useQuery(GET_WORKING_HOURS, {
    fetchPolicy: 'network-only',
  })
  const {
    state: { isMobile, currentUser, userPermissions, isClient },
  } = useContext(AppContext)
  if (error) return <Page404 />

  const canEdit = canUserEdit(userPermissions || currentUser, isClient)
  const workingHours = data?.getWorkingHours || []
  const dataSource = DAYS.map((name, dayOfWeek) => ({
    key: dayOfWeek,
    dayOfWeek,
    name,
    row: workingHours.find((row) => row.dayOfWeek === dayOfWeek),
  }))

  const columns = [
    { title: 'Day', dataIndex: 'name' },
    {
      title: 'Working Hours',
      dataIndex: 'row',
      render: (row) => describeDay(row),
    },
    {
      title: 'Action',
      key: 'action',
      width: 100,
      render: (text, record) =>
        canEdit && (
          <div className='action-icons'>
            <Tooltip title={isMobile ? '' : 'Edit'}>
              <EditTwoTone onClick={() => setEditDays([record.dayOfWeek])} />
            </Tooltip>
          </div>
        ),
    },
  ]

  return (
    <>
      <CustomMeta title='Working Hours' />
      <div className='main_dashboard_div'>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '12px',
            marginBottom: '20px',
          }}
        >
          <div
            style={{
              fontSize: isMobile ? '18px' : '24px',
              fontWeight: '600',
              lineHeight: '26px',
              letterSpacing: '-0.02em',
              textAlign: 'left',
              color: '#181C32',
            }}
          >
            Working Hours
          </div>
          {canEdit && (
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              <Button onClick={() => setEditDays([0, 1, 2, 3, 4, 5, 6])}>
                Edit all hours
              </Button>
              <Button onClick={() => setEditDays([1, 2, 3, 4, 5, 6])}>
                Edit Mon-Sat
              </Button>
              <Button onClick={() => setEditDays([0])}>Edit Sunday</Button>
            </div>
          )}
        </div>
        <Table
          loading={loading}
          dataSource={dataSource}
          columns={columns}
          pagination={false}
          onRow={(record) =>
            canEdit
              ? {
                  onClick: () => setEditDays([record.dayOfWeek]),
                  style: { cursor: 'pointer' },
                }
              : {}
          }
        />
      </div>

      {editDays && (
        <EditWorkingHours
          initialDays={editDays}
          workingHours={workingHours}
          onClose={() => setEditDays(null)}
        />
      )}
    </>
  )
}

export default WorkingHours
